module.exports = __webpack_public_path__ + "static/media/library.04390df7.svg";